export default __webpack_public_path__ + "static/media/darts.759654aa.svg";